import { render } from "./PointRule.vue?vue&type=template&id=6c660d9e&scoped=true"
import script from "./PointRule.vue?vue&type=script&lang=js"
export * from "./PointRule.vue?vue&type=script&lang=js"

import "./PointRule.vue?vue&type=style&index=0&id=6c660d9e&scoped=true&lang=css"

import exportComponent from "/var/www/html/minty.crm.frontend.merchant/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c660d9e"]])

export default __exports__